<template>
  <div class="cmp cmp-dialog-scorequery">
    <!-- 成绩查询 -->
    <el-dialog
      class="dialog-scorequery"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="620px"
    >
      <div slot="title" class="row-flex">
        <div class="row-flex-main text-left">
          <span class="txt-title">请选择查询方式</span>
        </div>
        <div class="row-flex-suffix">
          <span class="btn-close" @click="dialogVisible = false"></span>
        </div>
      </div>
      <div class="querytype-wrapper">
        <div
          v-for="(v, i) in querytypeList"
          :key="i"
          :class="['querytype-item', `querytype-item-${v.value}`]"
          @click="querytypeItemClick(v.value)"
        >
          <p>{{ v.label }}</p>
        </div>
      </div>
    </el-dialog>
    <!-- 个人查询 -->
    <el-dialog
      title="个人查询"
      :visible.sync="dialogPersonalVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
      width="620px"
    >
      <el-form :model="Form" :rules="rules" label-width="125px" ref="ruleForm">
        <el-form-item label="姓名" prop="studentName">
          <el-input
            v-model.trim="Form.studentName"
            :maxlength="100"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model.trim="Form.phone"
            :maxlength="11"
            placeholder="请输入报名时填写的手机号码(非大陆号码需加区号，只写数字)"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件号码后六位" prop="lastSixIdNumber">
          <el-input
            v-model.trim="Form.lastSixIdNumber"
            :maxlength="6"
            placeholder="请输入证件号码后六位(港澳证件不带括号)"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPersonalCancel">取消</el-button>
        <el-button type="primary" @click="dialogPersonalConfirm"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { EventBus } from '@/assets/scripts/bus';
import sxjmApi from '@/api/sxjm-api.js';
export default {
  data() {
    // 校验中文字符最少两位最大15位包含·
    let ChineseRules = function (rule, value, callback) {
      // const reg = /^[\u4e00-\u9fa5·]{2,15}$/;
      if (!value) {
        return callback(new Error('请输入姓名'));
        // } else if (!reg.test(value)) {
        //   return callback(new Error('您的姓名不符合规则，请修改后再试'));
      } else {
        callback();
      }
    };
    let idRules = function (rule, value, callback) {
      // const reg = /^[0-9A-Za-z(（)）]{6}$/;
      const reg = /^[0-9A-Za-z]{6}$/;
      if (!value) {
        return callback(new Error('请输入证件号码后六位'));
      } else if (!reg.test(value)) {
        return callback(new Error('证件号码后六位不符合规则，请修改后再试'));
      } else {
        callback();
      }
    };
    return {
      userInfo: {},
      dialogVisible: false,
      dialogPersonalVisible: false,
      querytypeList: [
        { label: '个人查询', value: 'personal' },
        { label: '团体查询', value: 'group' },
      ],
      Form: {
        studentName: '',
        phone: '',
        lastSixIdNumber: '',
      },
      rules: {
        studentName: [
          { required: true, validator: ChineseRules, trigger: 'change' },
        ],
        phone: [
          {
            required: true,
            message: '请输入报名时填写的手机号码',
            trigger: 'change',
          },
        ],
        lastSixIdNumber: [
          { required: true, validator: idRules, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      activityActive: 'activityActive',
    }),
    ...mapGetters(['isLogined']),
    queryExamScoreInfo() {
      let schedulers = this.activityActive.schedulers || [];
      let result = schedulers.filter(
        (item) => item.stage === 'QUERY_EXAM_SCORE',
      );
      return result[0] || {};
    },
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    show() {
      this.dialogVisible = true;
    },
    // 个人、团体成绩查询
    querytypeItemClick(type) {
      if (type === 'personal') {
        // 个人成绩查询
        this.dialogPersonalVisible = true;
        this.dialogVisible = false;
      } else if (type === 'group') {
        // 团体成绩查询
        this.dialogVisible = false;
        if (!this.isLogined) {
          EventBus.$emit('loginShow');
          return false;
        }
        this.$router.push({
          name: 'scorequery-group',
          query: {
            activityId: this.queryExamScoreInfo.activityId,
          },
        });
      }
    },
    dialogPersonalCancel() {
      this.dialogPersonalVisible = false;
      //   this.dialogPersonalReset();
    },
    dialogPersonalConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        let lastSixIdNumber = this.Form.lastSixIdNumber.replaceAll(
          /[（（））]/g,
          '',
        );
        this.userInfo = {};
        sxjmApi
          .validIdentity({
            activityId: this.queryExamScoreInfo.activityId,
            schedulerId: this.queryExamScoreInfo.schedulerId,
            phone: this.Form.phone,
            studentName: this.Form.studentName,
            lastSixIdNumber,
          })
          .then((res) => {
            res = res || {};
            if (res.code === 0 && res.data) {
              this.userInfo = res.data || {};
              this.dialogVisible = false;
              // this.setUserInfo(this.userInfo);
              localStorage.setItem('STU_UID', this.userInfo.stuUid || '');
              this.dialogPersonalCancel();
              this.$router.push({
                name: 'scorequery-personal',
                query: { activityId: this.queryExamScoreInfo.activityId },
              });
            } else {
              this.$message.error(res.msg || '请求错误');
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.msg);
          });
      });
    },
    dialogPersonalReset() {
      this.Form = {
        studentName: '',
        phone: '',
        lastSixIdNumber: '',
      };
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.cmp-dialog-scorequery {
  /deep/ .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      .txt-title {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      .btn-close {
        display: block;
        width: 24px;
        height: 24px;
        background: url('~@/assets/images/home/scorequery_btn_close.png')
          no-repeat center;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
    .querytype-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      .querytype-item {
        width: 200px;
        height: 280px;
        margin: 20px;
        position: relative;
        cursor: pointer;
        p {
          position: absolute;
          left: 0;
          bottom: 40px;
          width: 100%;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          text-align: center;
        }
      }
      .querytype-item-personal {
        background: url('~@/assets/images/home/scorequery_img_1.png') no-repeat
          center;
        background-size: 100% 100%;
      }
      .querytype-item-group {
        background: url('~@/assets/images/home/scorequery_img_2.png') no-repeat
          center;
        background-size: 100% 100%;
      }
    }
  }
  /deep/ .dialog-scorequery .el-dialog {
    background: url('~@/assets/images/home/scorequery_bg.png') no-repeat center;
    background-size: 100% 100%;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
